
import { defineComponent, ref, inject, computed, toRefs } from "vue";
import { useStore } from "vuex";
import Form from "./Form.vue";
import { useRoute } from "vue-router";
import Loader from '../../../../admin/payment_management/invoice/components/Loader.vue'

export default defineComponent({
  components: {
    Form,
    Loader,
  },
  setup() {
    const store = useStore();
    const router = useRoute();

    const loader_title = ref('Uploading')
    const loader_content = ref('Uploading and Sending Notification...')
    const visible_update_modal = ref(false);

    const columns = [
      {
          title: 'File Name',
          dataIndex: 'name'
      },
       {
          title: 'Description',
          dataIndex: 'description'
      },
      {
        title: "Action",
        dataIndex: "action",
        slots: { customRender: "action" },
        align: 'center'
      }
    ];
    const file_form = ref<InstanceType<typeof Form>>();
    const invoice = inject<any>('invoice');

    const create = () => {
      file_form.value?.create();
    };

    const edit = (record: any) => {
      file_form.value?.edit(record);
    };

    const remove = (row:any) => {
      invoice.invoice_files.map(function (value:any, key:any) {
        if (value.id == row.id) {
            invoice.invoice_files.splice(key, 1);
        }
      });
    };

    const deleteRecord = (row:any) => {
      loadUpdating()
      store.dispatch("InvoiceFile/destroy", row.id).then((response) => {
        visible_update_modal.value = false;
        invoice.invoice_files.map(function (value:any, key:any) {
          if (value.id == response.data.id) {
              invoice.invoice_files.splice(key, 1);
          }
        })
      })
      .catch((err) => {
        visible_update_modal.value = false
      });
      
    };

    const downloadRecord = (record: any) => {
      let api_url = process.env.VUE_APP_URL
      window.open(api_url + '/download/file/'+ record.id)
    }


    const isNew = computed(() =>
      router.name == "InvoiceCreate" ? true : false
    );

    const loadUpdating = () => {
      loader_title.value = "Updating"
      loader_content.value = "Updating and Sending Notification..."
      visible_update_modal.value = true
    }

    return {
      columns,
      invoice,
      file_form,
      isNew,
      create,
      edit,
      remove,
      deleteRecord,
      downloadRecord,
      visible_update_modal,
      loader_title,
      loader_content,
    };
  },
});
